
import React from 'react';

import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Typography
} from '@mui/material';

const RenderMiddleLabel = ({ label }) => {

    if (!label) return <></>

    return (
        <Box
            sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography
                variant="caption"
                component="div"
                sx={{ color: 'text.secondary', fontSize: 18 }}
            >
                {label}
            </Typography>
        </Box>
    )
}

const RenderLabel = ({ label }) => {

    if (!label) return <></>

    return (
        <Typography sx={{ mt: 2, color: 'text.secondary' }}>
            {label}
        </Typography>
    )
}

export function CommonLoader({
    open: _open = false,
    handleClose: _handleClose = () => { },
    title: _title = ``,
    CircularProgressProps: _CircularProgressProps = {
        variant: "",
        value: ""
    },
    middleLabel: _middleLabel = ``,
    bottomLabel: _bottomLabel = ''
}) {

    return (
        <Dialog onClose={_handleClose} open={_open}>
            <DialogTitle>
                {/* Consolidate Available Product Items */}
                {_title}
            </DialogTitle>
            <DialogContent>
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress
                            // variant={
                            //     dataInventory.length === dataInventoryLength ? "determinate" : ""
                            // }
                            // {
                            // ...dataInventory.length === dataInventoryLength ?
                            //     {
                            //         variant: "determinate",
                            //         value: 100
                            //     } : {}
                            // }
                            // value={
                            //     dataInventory.length === dataInventoryLength ? 100 : ""
                            // }
                            size={"8rem"}
                            {..._CircularProgressProps}
                        />
                        <RenderMiddleLabel
                            label={_middleLabel}
                        />
                    </Box>

                    <RenderLabel
                        label={_bottomLabel}
                    />

                </Box>


            </DialogContent>
        </Dialog>
    )
}

